export const NFTAddress = "0x50DA701325dbE8c734F714e3c7b18807E16234f5";
export const NFTMarketAddress = "0xA766b57E5Cc98331fAF860e7Af6DddfA6C3622b6";
export const ScoreAddress = "0x7Ae686721F7504fD3F71E9264cdbF80ec41e8Fc6";
export const BASE_GATEWAY_URI = "https://ipfs.io/ipfs/";
